import React, { useState, useEffect } from "react";

const ViewModal = ({ user, onClose }) => {
  console.log("Viewing item:", user);
  if (!user) return null;
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">

      <div className="bg-white rounded-xl shadow-lg w-full max-w-4xl p-6">

        {/* HEADER */}
        <div className="flex justify-between items-center border-b pb-3 mb-4">

          <h2 className="text-xl font-semibold text-gray-800">
            View Package
          </h2>

          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-lg"
          >
            ✕
          </button>

        </div>

        <div className="space-y-5 max-h-[75vh] overflow-y-auto">

          {/* PACKAGE NAME */}
          <div>

            <label className="block font-semibold text-gray-700 mb-1">
              Package Name
            </label>

            <div className="border rounded-md px-3 py-2 bg-gray-50">
              {user?.packageName}
            </div>

          </div>

          {/* PACKAGE DETAILS */}
          <div>

            <label className="block font-semibold text-gray-700 mb-1">
              Package Details
            </label>

            <div className="border rounded-md px-3 py-2 bg-gray-50">
              {user?.packageDetails}
            </div>

          </div>

          {/* MODULE CARDS */}
          <div className="space-y-4">

            {
              Object.values(
                user?.modules?.reduce((acc, item) => {

                  if (!acc[item.moduleId]) {

                    acc[item.moduleId] = {
                      moduleId: item.moduleId,
                      moduleName: item.moduleName,
                      subModules: []
                    };
                  }

                  acc[item.moduleId].subModules.push(
                    item.subModuleName
                  );

                  return acc;

                }, {})
              ).map((module) => (

                <div
                  key={module.moduleId}
                  className="border rounded-lg p-4 bg-gray-50"
                >

                  <h3 className="font-bold text-blue-600 mb-3">
                    {module.moduleName}
                  </h3>

                  <div className="flex flex-wrap gap-2">

                    {
                      module.subModules.map((sub, index) => (

                        <span
                          key={index}
                          className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm"
                        >
                          {sub}
                        </span>

                      ))
                    }

                  </div>

                </div>

              ))
            }

          </div>

        </div>

        {/* FOOTER */}
        <div className="mt-6 flex justify-end">

          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
          >
            Close
          </button>

        </div>

      </div>

    </div>
  );
};

export default ViewModal;


